import COLORS from '$variables/colors';

const DEFAULT_BORDER = 'none';
const DEFAULT_JUSTIFICATION = 'space-between';
const DEFAULT_PADDING = '4px 16px';

const looks = {
  primary: {
    color: COLORS.white,
    iconColor: COLORS.white,
    bgColor: COLORS.green,
    hoverColor: COLORS.white,
    hoverIconColor: COLORS.white,
    hoverBgColor: COLORS.greenLight,
    borderColor: DEFAULT_BORDER,
  },
  outlinePrimary: {
    color: COLORS.green,
    iconColor: COLORS.green,
    bgColor: COLORS.white,
    hoverColor: COLORS.white,
    hoverIconColor: COLORS.white,
    hoverBgColor: COLORS.green,
    borderColor: `1px solid ${COLORS.green}`,
    disabledColor: COLORS.green,
    disabledBgColor: COLORS.beige,
  },
  secondary: {
    color: COLORS.grey1,
    iconColor: COLORS.grey1,
    bgColor: COLORS.white,
    hoverColor: COLORS.grey1,
    hoverIconColor: COLORS.grey1,
    hoverBgColor: COLORS.beige,
    borderColor: `1px solid ${COLORS.grey}`,
  },
  secondaryPurple: {
    color: COLORS.purpleHeart,
    iconColor: COLORS.purpleHeart,
    bgColor: COLORS.white,
    hoverColor: COLORS.purpleHeart,
    hoverIconColor: COLORS.purpleHeart,
    hoverBgColor: COLORS.beige,
    borderColor: `1px solid ${COLORS.grey}`,
    focusBorderColor: `1px solid ${COLORS.shadow6}`,
    disabledColor: COLORS.grey1,
    disabledBgColor: COLORS.white,
    disabledBorderColor: `1px solid ${COLORS.grey}`,
  },
  iconOnlyGrey: {
    color: COLORS.black,
    iconColor: COLORS.black,
    bgColor: COLORS.grey2,
    hoverColor: COLORS.black,
    hoverIconColor: COLORS.black,
    hoverBgColor: COLORS.grey4,
    borderColor: DEFAULT_BORDER,
  },
  iconTransparentCircle: {
    color: COLORS.shadow5,
    iconColor: COLORS.shadow5,
    bgColor: 'transparent',
    hoverColor: COLORS.shadow5,
    hoverIconColor: COLORS.shadow5,
    hoverBgColor: COLORS.grey4,
    borderColor: DEFAULT_BORDER,
    borderRadius: '50%',
  },
  iconTransparent: {
    color: COLORS.shadow5,
    iconColor: COLORS.shadow5,
    bgColor: 'transparent',
    hoverColor: COLORS.shadow5,
    hoverIconColor: COLORS.shadow5,
    hoverBgColor: COLORS.grey4,
    borderColor: DEFAULT_BORDER,
  },
  purple: {
    color: COLORS.white,
    bgColor: COLORS.purpleHeart,
    hoverColor: COLORS.white,
    hoverBgColor: COLORS.purpleDark,
    borderColor: DEFAULT_BORDER,
    borderRadius: '4px',
  },
  outlineDefault: {
    color: COLORS.grey11,
    iconColor: COLORS.grey3,
    bgColor: COLORS.white,
    hoverColor: COLORS.grey11,
    hoverIconColor: COLORS.grey3,
    hoverBgColor: COLORS.grey1,
    borderColor: `1px solid ${COLORS.grey2}`,
    justification: DEFAULT_JUSTIFICATION,
  },
};

const sizes = {
  default: {
    icon: '18px',
    text: '14px',
    buttonHeight: '32px',
    padding: DEFAULT_PADDING,
    justification: DEFAULT_JUSTIFICATION,
  },
  medium: {
    icon: '18px',
    text: '14px',
    buttonHeight: '28px',
    padding: DEFAULT_PADDING,
    justification: DEFAULT_JUSTIFICATION,
  },
  large: {
    icon: '18px',
    text: '14px',
    buttonHeight: '40px',
    padding: DEFAULT_PADDING,
    justification: DEFAULT_JUSTIFICATION,
  },
  iconDefault: {
    icon: '18px',
    buttonHeight: '32px',
    buttonWidth: '32px',
    padding: '4px 7px',
    justification: 'center',
  },
  iconMedium: {
    icon: '24px',
    buttonHeight: '32px',
    buttonWidth: '32px',
    padding: '0',
    justification: 'center',
  },
  iconLarge: {
    icon: '24px',
    buttonHeight: '40px',
    buttonWidth: '40px',
    padding: '4px 10px',
    justification: 'center',
  },
};

export { looks, sizes };
